export const fileExtensions: { [key: string]: string } = {
  pdf: '.pdf',
  excel: '.xlsx',
  csv: '.csv',
  // Add more mappings for other types if needed
};
